import { useMutation, useQuery, useQueryClient } from "react-query";
import { createNote, deleteNote, fetchDueNotes, fetchNoteById, fetchNotes, fetchProjectNotes, reviewNote, updateNote } from "../api/notesApi";

export function useNoteById(token, id) {
    return useQuery({
        queryKey: ['notes', id],
        queryFn: () => fetchNoteById(id, token),
        enabled: !!token && !!id,
    });
}

export function useDeleteNote(token) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => deleteNote(id, token),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['notes'] });
            queryClient.invalidateQueries({ queryKey: ['dueNotes'] });
            queryClient.invalidateQueries({ queryKey: ['projectNotes'] });
        },
    });
}

export function useCreateNote(token) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (noteData) => createNote(token, noteData),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['notes'] });
            queryClient.invalidateQueries({ queryKey: ['projectNotes'] });
        },
    });
}

export function useUpdateNote(token) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, noteData }) => updateNote(id, token, noteData),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['notes'] });
            queryClient.invalidateQueries({ queryKey: ['projectNotes'] });
        },
    });
}

export function useReviewNote(token) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id) => reviewNote(id, token),
        onSuccess: (reviewedNote) => {
            queryClient.setQueryData(['notes', reviewedNote.id], reviewedNote);
            queryClient.invalidateQueries({ queryKey: ['notes'] });
            queryClient.invalidateQueries({ queryKey: ['dueNotes'] });
            queryClient.invalidateQueries({ queryKey: ['projectNotes'] });
        },
    });
}

export function useNotes(token) {
    return useQuery({
        queryKey: ['notes'],
        queryFn: () => fetchNotes(token),
        enabled: !!token,
        initialData: [],
    });
}

export function useDueNotes(token) {
    return useQuery({
        queryKey: ['dueNotes'],
        queryFn: () => fetchDueNotes(token),
        enabled: !!token,
        initialData: [],
    });
}

export function useProjectNotes(token, projectId) {
    return useQuery({
        queryKey: ['projectNotes', projectId],
        queryFn: () => fetchProjectNotes(token, projectId),
        enabled: !!token && !!projectId,
        initialData: [],
    });
}
